import { Component, OnInit, Input, ViewChild, TemplateRef, Output, EventEmitter } from '@angular/core';
import { ToasterService } from 'angular2-toaster';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import * as _ from 'lodash';
import * as moment from 'moment';
import swal from 'sweetalert2';
import { Store } from '@ngrx/store';
import * as fromCommonStore from '../../../store';
import * as fromRootStore from '../../../reducers';
import { AddDropReasonComponent } from './addDropReason.component';
import { ServiceWalkInService, SubscribeService, EditService } from '../../../services/index';
import { ServiceWalkInModel } from '../../../model/index';
import { clientHistoryComponent } from '../../common/clientHistory';
import { serviceReplyComponent } from './serviceReply.component';
import { connect } from 'net';

@Component({
    selector: 'courier-details',
    templateUrl: './addCourierDetails.component.html'
})

export class addCourierDetailsComponent implements OnInit {

    subscription: Subscription;
    headOffCourierDet = [];
    serviceInData = [];
    salesBillentryDetails = [];
    paramsRes = [];
    courierNoCtrl: FormControl;
    courierNameCtrl: FormControl;
    @Input() set courierDetails(val: any) {
        this.serviceInData.push(val['serviceinData']);
        this.salesBillentryDetails.push(val['salesbillentryDetails']),
            this.paramsRes.push(val['params']);
    }
    @Output() courierLoadevent = new EventEmitter();
    constructor(public store: Store<fromRootStore.State>, public toasterService: ToasterService, public subscribeService: SubscribeService, public bsModalRef: BsModalRef, private serviceWalkInService: ServiceWalkInService,) {
        this.courierNoCtrl = new FormControl('', [
            Validators.required
        ]);
        this.courierNameCtrl = new FormControl('', [
            Validators.required
        ]);
    }

    ngOnInit(): void {

    }

    onSaveCourierDet(): void {
        let that = this,
            testingDate = moment(this.serviceInData['service_dates']).format('YYYY-MM-DD'),
            courierDate = moment(this.serviceInData['courier_date']).format('YYYY-MM-DD'),
            headOffCourierdate = moment(new Date()).format('YYYY-MM-DD'),

            data = {
                from_branch_id: this.serviceInData[0].from_branch,
                ser_id: this.serviceInData[0].ser_id,
                auto_no: this.serviceInData[0].auto_no,
                to_branch: this.serviceInData[0].to_branch,
                process: this.serviceInData[0].process,
                courier_no: this.serviceInData[0].courier_no,
                return_reason: this.serviceInData[0].return_reason,
                courier_date: courierDate,
                courier_name: this.serviceInData[0].courier_name,
                headOffCourier_no: this.headOffCourierDet['courier_no'],
                headOffCourier_name: this.headOffCourierDet['courier_name'],
                headOffCourierDate: headOffCourierdate,
                date: testingDate,
                mode: this.paramsRes[0].mode,
                tabParams: this.paramsRes[0].tabParams,
                status: "exported",
                export: "No"
                //salesBillentryDetails: JSON.stringify(this.salesBillentryDetails)
            };
        this.serviceWalkInService
            .addSaveImportExport(data)
            .then(function (res: any) {
                if (res.success) {
                    swal('SUCCESS', res.message, 'success');
                    that.subscribeService.subReloadServiceGrid();
                    that.bsModalRef.hide()
                    that.serviceInData = [];
                    that.salesBillentryDetails = [];
                    that.subscribeService.subScribeDeleteActiveTab();
                } else {
                    swal('ERROR', res.message, 'error');
                }

            })
            .catch(function (error: any) {
                let res = JSON.parse(error._body);
                swal('ERROR', res.message, 'error');
            });
    }

}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/serviceWalkIn/addCourierDetails.component.ts